import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { protectedResources } from '../b2c-config';
import { PatchUploadStatus } from '../models/common/patchUploadStatus';
import { forkJoin, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PatchManagementService {
  public networkListenerObserver$ = new Subject();
  constructor(private http: HttpClient) {
  }
  public getReleaseTypes() {
    return this.http.get(`${protectedResources.etlApi.endpoint}api/ReleaseManagement/GetReleaseTypes`);
  } 
  public getPatchUploadSaaSToken(productType,releaseType) {
    return this.http.get(`${protectedResources.etlApi.endpoint}api/ReleaseManagement/GenerateReleaseUploadSaaSToken?ProductType=${productType}&ReleaseType=${releaseType}`);
  } 
  public createPatchUpload(patchDtails) {
    return this.http.post(`${protectedResources.realizerApi.endpoint}api/ReleaseManagement/AddRelease`,patchDtails);
  } 
  public updatePatchUpload(patchDtails) {
    return this.http.post(`${protectedResources.realizerApi.endpoint}api/ReleaseManagement/UpdateRelease`,patchDtails);
  } 

  public markUploadsAsFailed(uploads: any): Promise<boolean> {
    const subscription: Array<any> = [];
    return new Promise((resolve, reject) => {
      uploads.forEach((x) => {
        subscription.push(this.updatePatchUpload({ id: x.id, eventCode: PatchUploadStatus.UploadFailed, comments: "Unknown Error" }))
      });
      forkJoin(subscription).subscribe({
        next: () => {
          resolve(true);
        }
        , error: () => {
          reject();
        }
      });
    })
  }
  public notifyNetworkReconnectSubscription (){
    this.networkListenerObserver$.next(true);
}
public getNetworkReconnection(){
    return this.networkListenerObserver$;
}
}
